/** 工行数币一分钱乘车3月活动 - 升级指引页 */
<template>
  <div class="main-box">
    <img
      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/MarActivity/guide.png"
      alt=""
    />
    <img
      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/MarActivity/guide2.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: 'digitalMarActivityGuide',
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.main-box {
  img {
    display: flex;
    width: 100%;
    height: auto;
  }
}

.note-intro,
.activity-rules {
  position: relative;
}

.intro-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 37px;
  width: 178px;
  height: 32px;
  margin: 0 auto;
  line-height: 32px;
  text-align: center;
  color: transparent;
}

  .activity-rules .upgrade-btn {
    position: absolute;
    bottom: 3%;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 80%;

    &:active {
      opacity: 0.8;
    }
  }

</style>
